'use client'

import { Button, Image } from '@vinted/web-ui'

import { Pencil24 } from '@vinted/monochrome-icons'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useSession } from '@marketplace-web/shared/session-data'

import { navigateToPage } from '@marketplace-web/browser/browser-navigation-util'
import { clickEvent } from '@marketplace-web/seller-engagement-tools/seller-engagement-tools-data'

import { SELLER_INSIGHTS_TAB_NAME } from '../../../constants/insights'
import { EDIT_ITEM_URL } from '../../../constants/routes'

type Props = {
  accessibilityDescription: string
  photoUrl: string
  itemId: number
}

const SellerInsightsPhotoThumbnail = ({ accessibilityDescription, photoUrl, itemId }: Props) => {
  const { track } = useTracking()
  const { user: currentUser } = useSession()

  const handleButtonClick = () => {
    track(
      clickEvent({
        screen: 'current_user_profile',
        target: 'edit_item',
        targetDetails: JSON.stringify({
          item_id: itemId,
          user_id: currentUser?.id,
        }),
      }),
    )

    navigateToPage(EDIT_ITEM_URL(itemId, SELLER_INSIGHTS_TAB_NAME))
  }

  return (
    <div className="u-position-relative u-inline-block seller-insights-photo-recommendations__item">
      <button type="button" onClick={handleButtonClick}>
        <Image
          src={photoUrl}
          scaling="cover"
          styling="rounded"
          ratio="square"
          size="x4-large"
          alt={accessibilityDescription}
          testId={`item-to-improve-${itemId}`}
        />
      </button>
      <div className="u-position-absolute u-right u-bottom u-zindex-bump u-margin-medium">
        <Button
          inline
          inverse
          iconName={Pencil24}
          size="medium"
          styling="filled"
          theme="amplified"
          onClick={handleButtonClick}
          aria={{ 'aria-label': accessibilityDescription }}
        />
      </div>
    </div>
  )
}

export default SellerInsightsPhotoThumbnail
